export const DAMAGE_CONDITIONS = [
  { value: 'none', label: 'None' },
  { value: 'minor', label: 'Minor' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'major', label: 'Major' },
  { value: 'destroyed', label: 'Destroyed/Catastrophic' },
];

export function conditionLabel(value) {
  return DAMAGE_CONDITIONS.find((c) => c.value === value)?.label || value || '—';
}
